import { z } from 'zod';

export const MembershipToolName = 'membership';

/**
 * Membership tool arguments schema
 */
export const membershipToolArgsSchema = z.object({
  query: z
    .string()
    .describe(
      'User query about membership status, profile, or authentication. The tool will intelligently route based on authentication state.',
    ),
});

export type MembershipToolArgs = z.infer<typeof membershipToolArgsSchema>;
